import { gql } from '@apollo/client';

export const sendEmailMutation = gql`
  mutation sendVoucherConfirmationEmail($voucherAlias: String!) {
    sendVoucherConfirmationEmail(voucherAlias: $voucherAlias)
  }
`;
